import React from 'react'
import Seo from '@widgets/Seo'
import Divider from '@components/Divider'
import PageTitle from '@components/PageTitle'
import ContactInfo from '@widgets/ContactInfo'
import Navigation from '@components/Navigation'
import { Layout, Stack, Main, Sidebar } from '@layout'
import attachSocialIcons from '@helpers/attachSocialIcons'
import useSiteMetadata from '@helpers-blog/useSiteMetadata'


const styles = {
  social: {
    mb: [3, 0]
  },
  navHeader: {
    display: [`none`, `block`]
  }
}


const PageContact = props => {
  const { social } = useSiteMetadata()

  return (
  <Layout {...props}>
    <Seo title='Contact' />
    <Divider />
    <Stack>
      <Main>
        <PageTitle
          header="Let's Connect"
          subheader='I am always up for tour and talk. Either you have any specific agenda or just want to have a social talk, reach out to me.'
        />
        <Navigation
        items={attachSocialIcons(social)}
        variant={[`horizontal`, `vertical`]}
        wrapperStyle={styles.social}
      />
      </Main>
      <Sidebar>
        <ContactInfo />
      </Sidebar>
    </Stack>
  </Layout>
)

}

export default PageContact
